import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    window.onclick = () => {
        console.log(4234)
    }
    window.addEventListener('scroll', () => {
        console.log(3455445)
    })
    return (
        <div className='fixed w-full z-10 ' style={{ borderBottom: '2px solid grey' }}>
            <div className="navbar bg-base-100">
                <div className="navbar-start">
                    <div className="dropdown">

                        <label tabIndex='0' className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex='0' className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <li><Link className='text-xl' to='/'>Home</Link></li>
                            <li><a className='text-xl' href='/#My_skills'>My Skill</a></li>
                            <li><a className='text-xl' href='/#about'>About Me</a></li>
                            <li><a className='text-xl' href='/#Contact'>Contact Me</a></li>
                            <li><a className='text-xl' href='/#Projects'>Projects</a></li>
                            <li><a className='text-xl' href='https://drive.google.com/file/d/1WGDOTFSpg9-MtUtZ3MIwiAJ43hRwVtpz/view?usp=sharing'  target="_blank" rel="noreferrer">My Resume</a></li>

                        </ul>
                    </div>
                    <Link className="btn btn-ghost normal-case text-2xl font-bold" to='/'>SRAKIB17</Link>

                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        <li><Link className='text-xl' to='/'>Home</Link></li>
                        <li><a className='text-xl' href='/#My_skills'>My Skill</a></li>
                        <li><a className='text-xl' href='/#about'>About Me</a></li>
                        <li><a className='text-xl' href='/#Contact'>Contact Me</a></li>
                        <li><a className='text-xl' href='/#Projects'>Projects</a></li>
                        <li><a className='text-xl' href='https://drive.google.com/file/d/1WGDOTFSpg9-MtUtZ3MIwiAJ43hRwVtpz/view?usp=sharing' target="_blank" rel="noreferrer">My Resume</a></li>
                    </ul>
                </div>


                <div className="navbar-end mr-4">

                </div>
            </div>

        </div>
    );
};

export default Header;